import { useState, useRef, useEffect } from "react";
var Direction = /*#__PURE__*/function (Direction) {
  Direction["Forward"] = "forward";
  Direction["Backward"] = "backward";
  return Direction;
}(Direction || {});
var CardClass = /*#__PURE__*/function (CardClass) {
  CardClass["CardCurrent"] = "card-current";
  CardClass["CardBehind1"] = "card-behind-1";
  CardClass["CardBehind2"] = "card-behind-2";
  CardClass["CardHidden"] = "card-hidden";
  CardClass["ExitingToLeft"] = "exiting-to-left";
  CardClass["EnteringFromLeft"] = "entering-from-left";
  return CardClass;
}(CardClass || {});
export const useCarousel = (totalItems, onClickCallback, onSwipeCallback) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [previousIndex, setPreviousIndex] = useState(null);
  const isAnimatingRef = useRef(false);
  const directionRef = useRef(null);
  const isDraggingRef = useRef(false);
  const dragDistanceRef = useRef(0);
  const touchStartRef = useRef(0);
  const touchYRef = useRef(0);
  const animationTimeoutRef = useRef(null);
  useEffect(() => {
    return () => {
      if (animationTimeoutRef.current) clearTimeout(animationTimeoutRef.current);
    };
  }, []);
  const goToCard = index => {
    if (isAnimatingRef.current || index === currentIndex || index < 0 || index >= totalItems) return;
    const newDirection = index > currentIndex ? Direction.Forward : Direction.Backward;
    directionRef.current = newDirection;
    isAnimatingRef.current = true;
    setPreviousIndex(currentIndex);
    animationTimeoutRef.current = setTimeout(() => {
      setCurrentIndex(index);
      setPreviousIndex(null);
      directionRef.current = null;
      isAnimatingRef.current = false;
      if (onSwipeCallback) onSwipeCallback(index, currentIndex);
    }, 400);
  };
  const nextCard = () => {
    if (currentIndex < totalItems - 1) {
      goToCard(currentIndex + 1);
    }
  };
  const prevCard = () => {
    if (currentIndex > 0) {
      goToCard(currentIndex - 1);
    }
  };
  const getCardClass = (index, baseClassName = '') => {
    let className = baseClassName || '';
    if (!isAnimatingRef.current || directionRef.current === null || previousIndex === null) {
      switch (index) {
        case currentIndex:
          className += ` ${CardClass.CardCurrent}`;
          break;
        case currentIndex + 1:
          className += ` ${CardClass.CardBehind1}`;
          break;
        case currentIndex + 2:
          className += ` ${CardClass.CardBehind2}`;
          break;
        default:
          className += ` ${CardClass.CardHidden}`;
          break;
      }
      return className.trim();
    }
    if (directionRef.current === Direction.Forward) {
      switch (index) {
        case previousIndex:
          className += ` ${CardClass.ExitingToLeft}`;
          break;
        case currentIndex:
          className += ` ${CardClass.CardCurrent} ${CardClass.EnteringFromLeft}`;
          break;
        case currentIndex + 1:
          className += ` ${CardClass.CardBehind1}`;
          break;
        case currentIndex + 2:
          className += ` ${CardClass.CardBehind2}`;
          break;
        default:
          className += ` ${CardClass.CardHidden}`;
          break;
      }
    } else if (directionRef.current === Direction.Backward) {
      switch (index) {
        case previousIndex - 1:
          className += ` ${CardClass.CardCurrent} ${CardClass.EnteringFromLeft}`;
          break;
        case currentIndex:
          className += ` ${CardClass.CardBehind1}`;
          break;
        case currentIndex + 1:
          className += ` ${CardClass.CardBehind2}`;
          break;
        case currentIndex + 2:
          className += ` ${CardClass.CardHidden}`;
          break;
        default:
          className += ` ${CardClass.CardHidden}`;
          break;
      }
    }
    return className.trim();
  };
  const handleTouchStart = e => {
    if (isAnimatingRef.current) return;
    touchStartRef.current = e.touches[0].clientX;
    touchYRef.current = e.touches[0].clientY;
    dragDistanceRef.current = 0;
    isDraggingRef.current = true;
  };
  const handleTouchMove = e => {
    if (!isDraggingRef.current) return;
    const touchX = e.touches[0].clientX;
    const touchYCurrent = e.touches[0].clientY;
    const diffX = touchStartRef.current - touchX;
    const diffY = Math.abs(touchYRef.current - touchYCurrent);
    dragDistanceRef.current = Math.abs(diffX);
    if (Math.abs(diffX) > diffY) {
      e.preventDefault();
    } else if (diffY > Math.abs(diffX) * 1.5 && diffY > 10) {
      isDraggingRef.current = false;
    }
  };
  const handleTouchEnd = e => {
    if (!isDraggingRef.current || isAnimatingRef.current) {
      isDraggingRef.current = false;
      return;
    }
    const touchEnd = e.changedTouches[0].clientX;
    const diff = touchStartRef.current - touchEnd;
    if (Math.abs(diff) > 30) {
      if (diff > 0) {
        nextCard();
      } else {
        prevCard();
      }
      e.preventDefault();
    } else {
      if (onClickCallback) onClickCallback(currentIndex);
    }
    isDraggingRef.current = false;
    dragDistanceRef.current = 0;
  };
  const handleKeyDown = e => {
    if (e.key === 'ArrowLeft') {
      prevCard();
    } else if (e.key === 'ArrowRight') {
      nextCard();
    }
  };
  return {
    currentIndex,
    previousIndex,
    isDragging: isDraggingRef.current,
    dragDistance: dragDistanceRef.current,
    goToCard,
    nextCard,
    prevCard,
    getCardClass,
    handleTouchStart,
    handleTouchMove,
    handleTouchEnd,
    handleKeyDown
  };
};
//# sourceMappingURL=BenefitCarouselHook.js.map